<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Configura galerias de grids por tela</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="ConfigGrid.plgId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" v-if="ListaTelas!=''">
                                    <v-select v-model="ConfigGrid.cdtId" label="Telas" :items="ListaTelas"
                                        item-title="cdtNome" item-value="cdtId" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="ConfigGrid.plgNome" :rules="nameRules" :counter="200"
                                        label="Nome Galeria" variant="underlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field v-model="ConfigGrid.plgOrdem" label="Ordem" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select v-model="ConfigGrid.plgVisivel" label="Visível" :items="Status"
                                        item-title="nome" item-value="plgVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="ConfigGrid.plgLargura" label="Largura px (width)" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="ConfigGrid.plgAltura" label="Altura px (height) " type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="ConfigGrid.plgQtd" label="Quantidade" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="ConfigGrid.plgId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(ConfigGrids)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-plgVisivel="item">
                            <span>{{ item.plgVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-plgOrdem="item">
                            <span>{{ parseInt(item.plgOrdem) }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'ConfigListaGridsTelasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        ConfigGrid: {
            plgId: 0,
            cdtId: '',
            plgNome: '',
            plgOrdem: '',
            plgVisivel: '',
            plgLargura: '',
            plgAltura: '',
            plgQtd: '',
        },
        ConfigGrids: [],
        ListaTelas:[{ cdtId: 14, cdtNome: "Produtos" }],
        selectedVisivel: null,
        Status: [{ nome: "Sim", plgVisivel: true }, { nome: "Não", plgVisivel: false }],
        nameRules: [
            value => {
                if (value?.length <= 200) return true
                return 'Nome pode conter até 200 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "plgId", sortable: true, },
            { text: "Tela", value: "admCadastroTelas.cdtNome", sortable: true, },
            { text: "Nome", value: "plgNome", sortable: true, },
            { text: "Ordem", value: "plgOrdem", sortable: true, },
            { text: "Visivel", value: "plgVisivel", sortable: true, },
            { text: "Largura", value: "plgLargura", sortable: true, },
            { text: "Altura", value: "plgAltura", sortable: true, },
            { text: "Qtde", value: "plgQtd", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                plgOrdem: parseInt(item.plgOrdem),
            };
            });
        },
        Limpar() {
            this.ConfigGrid.plgId = 0;
            this.ConfigGrid.cdtId = "";
            this.ConfigGrid.plgNome = "";
            this.ConfigGrid.plgOrdem = "";
            this.ConfigGrid.plgVisivel = "";
            this.ConfigGrid.plgLargura = "";
            this.ConfigGrid.plgAltura = "";
            this.ConfigGrid.plgQtd = "";
            this.selectedVisivel = "";
            this.Get();
        },
        Add() {
            if (this.ConfigGrid.plgNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ConfigGrid.plgOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.ConfigGrid.plgVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ConfigGrid.cdtId == ""){
                this.$mensagemAviso("Tela obrigatória.")
            }
            else if (this.ConfigGrid.plgAltura == ''){
                this.$mensagemAviso("Altura Obrigatório.")
            }
            else if (this.ConfigGrid.plgLargura == ''){
                this.$mensagemAviso("Largura Obrigatório.")
            }
            else if (this.ConfigGrid.plgQtd === ''){
                this.$mensagemAviso("Quantidade Obrigatório.")
            }
            else {
                this.ConfigGrid.plgOrdem = parseInt(this.ConfigGrid.plgOrdem)
                this.ConfigGrid.plgAltura = parseInt(this.ConfigGrid.plgAltura)
                this.ConfigGrid.plgLargura = parseInt(this.ConfigGrid.plgLargura)
                this.ConfigGrid.plgQtd = parseInt(this.ConfigGrid.plgQtd)
                this.ConfigGrid.AdmCadastroTelas = { cdtId: this.ConfigGrid.cdtId};
                axios.post(`/Process/ProListaGaleriaGrids/Add`, this.ConfigGrid)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            console.log(this.ConfigGrid)
            if (this.ConfigGrid.plgNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ConfigGrid.plgOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.ConfigGrid.plgVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ConfigGrid.cdtId == ""){
                this.$mensagemAviso("Tela obrigatória.")
            }
            else if (this.ConfigGrid.plgAltura == ''){
                this.$mensagemAviso("Altura Obrigatório.")
            }
            else if (this.ConfigGrid.plgLargura == ''){
                this.$mensagemAviso("Largura Obrigatório.")
            }
            else if (this.ConfigGrid.plgQtd === ''){
                this.$mensagemAviso("Quantidade Obrigatório.")
            }
            else {
                this.ConfigGrid.plgOrdem = parseInt(this.ConfigGrid.plgOrdem)
                this.ConfigGrid.plgAltura = parseInt(this.ConfigGrid.plgAltura)
                this.ConfigGrid.plgLargura = parseInt(this.ConfigGrid.plgLargura)
                this.ConfigGrid.plgQtd = parseInt(this.ConfigGrid.plgQtd)
                this.ConfigGrid.AdmCadastroTelas = { cdtId: this.ConfigGrid.cdtId};
                axios.put(`/Process/ProListaGaleriaGrids/Update`, this.ConfigGrid)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.ConfigGrid = item;
            this.ConfigGrid.cdtId = item.admCadastroTelas.cdtId
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.plgId;
                axios.delete(`/Process/ProListaGaleriaGrids/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
                axios.get(`/Process/ProListaGaleriaGrids/GetAll`)
                .then(response => {
                    this.ConfigGrids = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
